import {
  BasicProductDataResponse,
  BranchResponse,
  ProductDetailsResponse,
} from '@/src/types/catalog';
import HttpCLient from '@/src/lib/utils/httpClient';
import { redirect } from 'next/navigation';

type Store = {
  name: string;
  id: number;
  logoUrl: string;
  arabicName: string;
  englishName: string;
};
export type ResponseProductDetailsType = ProductDetailsResponse & {
  status?: number;
  store: Store;
  branch: BranchResponse;
  similarProducts: (BasicProductDataResponse & {
    integrationId: string;
  })[];
};
class ProductDetails extends HttpCLient {
  async getProductDetails(branchId: string, productId: string) {
    try {
      const data = await this.get(`mobile/branches/${branchId}/products/${productId}`);

      return data as ResponseProductDetailsType;
    } catch (error) {
      redirect('/not-found');
    }
  }
}

export const productDetailsApi = new ProductDetails();
